import { render, staticRenderFns } from "./CardRecipe.vue?vue&type=template&id=560b735f&"
import script from "./CardRecipe.vue?vue&type=script&lang=js&"
export * from "./CardRecipe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports